import React, { Component } from "react";
import "./Authentication.css";
import { Link, Redirect } from "react-router-dom";
import LoadingPage from "../../components/Loading/Loading";
import config from "../../config";
import FilledInput from "@mui/material/FilledInput";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Select from "react-select";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import SignUpCommercial from "./SignUpCommercial/SignUpCommercial";

// Define role constants at the top of the file
const COMMERCIAL_ROLES = ["Commercial Admin", "Commercial Staff"];
const ADMIN_ROLES = [
  "Admin",
  "Staff",
  "Service Center Admin",
  "Service Center Manager",
  "Service",
  "Contractor",
];

const OPTION_PATH = [
  { value: "", label: "Customer" },
  { value: "commercial", label: "Commercial" },
];
export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      rememberMe: false,
      invalidLoginTriggered: false,
      successConvertTriggered: false,
      redirect: false,
      isCommercial: false,
      showPassword: false,
      isCommercialUrl: window.location.href.includes("commercial"),
      selectPage: window.location.href.includes("commercial")
        ? OPTION_PATH[1]
        : OPTION_PATH[0],
      pageStoreLocationId: [{ value: "", label: "" }],
      showSelectLocation: false,
    };
  }

  validateForm() {
    if (this.state.email.length === 0) {
      this.setState({
        invalidLoginTriggered: "Please provide a email.",
      });
    } else if (this.state.password.length === 0) {
      this.setState({
        invalidLoginTriggered: "Please provide a password.",
      });
    } else {
      return true;
    }

    return false; //If not in else, then it's failed
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  handleClickShowPassword = () =>
    this.setState({ showPassword: !this.state.showPassword });

  handleSubmit = async (event) => {
    event.preventDefault();

    const formValidated = this.validateForm();

    if (formValidated) {
      this.setState({ isLoading: true });

      let url = config.backendServer + "login/";

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: this.state.password,
          email: this.state.email,
          site_type: "admin",
        }),
      })
        .then(async (response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            const error = await response.json();
            throw error;
          }
        })
        .then((response) => {
          const roleUser = response && JSON.parse(response).user.role;
          const isCommercialUrl = window.location.href.includes("commercial");
          if (response) {
            const handleLogin = (isCommercial = false) => {
              this.props.onLogin(response, this.state.rememberMe, () => {
                this.setState({
                  redirect: true,
                  isLoading: false,
                  isCommercial,
                });
              });
            };

            if (isCommercialUrl) {
              if (COMMERCIAL_ROLES.includes(roleUser)) {
                handleLogin(true);
              } else if (roleUser === "Admin") {
                handleLogin(false);
              } else {
                this.setState({
                  isLoading: false,
                  invalidLoginTriggered: !this.state.invalidLoginTriggered
                    ? `${this.state.email} is a ${roleUser}, not allowed to access commercial page`
                    : this.state.invalidLoginTriggered,
                });
              }
            } else if (ADMIN_ROLES.includes(roleUser)) {
              handleLogin();
            } else {
              this.setState({
                isLoading: false,
                invalidLoginTriggered: !this.state.invalidLoginTriggered
                  ? `${this.state.email} is a ${roleUser}, not allowed to access admin page`
                  : this.state.invalidLoginTriggered,
              });
            }
          }
        })
        .catch((resp) => {
          this.setState({
            isLoading: false,
          });
          const regex = new RegExp(`[${["{", "}", '"'].join("")}]`, "g");
          const errorDetail =
            resp.non_field_errors || JSON.stringify(resp).replace(regex, "");
          const isCommercialUrl = window.location.href.includes("commercial");

          if (
            (isCommercialUrl && errorDetail[0].includes("credentials")) ||
            (isCommercialUrl && errorDetail[0].includes("permission"))
          ) {
            this.setState({
              showConfirm: true,
            });
          } else {
            this.setState({
              invalidLoginTriggered: errorDetail,
            });
          }
        });
    }
  };

  handleSignUpCommercial = (payload) => {
    let url = config.backendServer + "commercial-registration/";
    this.setState({
      isLoading: true,
      showSelectLocation: false,
    });
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (response.status === 201) {
          return response.text();
        } else {
          const error = await response.json();
          throw error;
        }
      })
      .then((response) => {
        console.log("response ", response);
        this.setState({
          successConvertTriggered:
            "Your email is not registered yet. Your request has already been submitted for administrator approval. Please check again later.",
          invalidLoginTriggered: null,
          email: "",
          password: "",
          isLoading: false,
        });
      })
      .catch((resp) => {
        const regex = new RegExp(`[${["{", "}", '"'].join("")}]`, "g");
        const errorDetail =
          resp.non_field_errors || JSON.stringify(resp).replace(regex, "");
        this.setState({
          invalidLoginTriggered: errorDetail,
          successConvertTriggered: null,
          password: "",
          isLoading: false,
        });
      });
  };
  onSelectChagePath = (option) => {
    this.setState({ selectPage: option });
    if (option.value === "commercial") {
      window.location.href = "commercial";
    } else {
      window.location.href = config.customerBaseUrl + "login";
    }
  };

  render() {
    if (this.state.isLoading) {
      return <LoadingPage small={true} />;
    } else if (this.state.redirect) {
      if (this.state.isCommercial)
        return <Redirect to={"/commercial/tickets"} />;
      else return <Redirect to={"/"} />;
    }
    return (
      <div>
        <h2 className={"auth-page-header"}>Login</h2>
        {this.state.invalidLoginTriggered && (
          <div className={"incorrectAuthenticationText"}>
            {this.state.invalidLoginTriggered}
          </div>
        )}
        {!this.state.invalidLoginTriggered &&
          this.state.successConvertTriggered && (
            <div className={"successAuthenticationText"}>
              {this.state.successConvertTriggered}
            </div>
          )}
        {this.state.isCommercialUrl && (
          <div className="mt-2 mb-3">
            <label>Select Page</label>
            <Select
              data-testid="assign-to-select"
              value={this.state.selectPage}
              options={OPTION_PATH}
              onChange={this.onSelectChagePath}
            />
          </div>
        )}

        <form aria-label="login-form" onSubmit={this.handleSubmit}>
          <div className="auth-form-field">
            <label>Email</label>
            <input
              data-testid="email"
              type={"text"}
              required={true}
              id={"email"}
              value={this.state.email}
              onChange={this.handleChange}
              style={{
                width: "100%",
                border: "1px solid #ddd",
                backgroundColor: "white",
              }}
              placeholder="input your email"
            />
          </div>

          <div className="auth-form-field">
            <label>Password</label>
            <FilledInput
              id="password"
              type={this.state.showPassword ? "text" : "password"}
              style={{
                width: "100%",
                border: "1px solid #ddd",
                backgroundColor: "white",
              }}
              autoComplete={false}
              value={this.state.password}
              onChange={this.handleChange}
              placeholder="input your password"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={this.handleMouseDownPassword}
                    edge="end"
                  >
                    {this.state.showPassword ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
          </div>
          <div className={"auth-options-section clearfix"}>
            <Link id="loginForgotPassword" to={window.location.pathname === "/commercial" ? "/commercial/forgot-password/" : "/forgot-password"}>
              Forgot Password
            </Link>
          </div>
          <button className="k-btn k-btn-primary-full" type="submit">
            Login
          </button>
        </form>

        <Modal
          isOpen={this.state.showConfirm}
          contentLabel={"Confirmation"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showConfirm: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              <h6>Confirm Registration</h6>
            </div>
            <div className="card-body">
              <h6>
                You don’t have an account yet. Would you like to register now?
              </h6>
            </div>
            <div className="card-footer">
              <div className="row ">
                <div className="col-6 text-right ">
                  <button
                    type="button"
                    className={"btn btn-outline-success"}
                    onClick={() => {
                      this.setState({
                        showConfirm: false,
                        showSelectLocation: true,
                      });
                    }}
                  >
                    Yes
                  </button>
                </div>
                <div className="col-6 text-left">
                  <button
                    type={"button"}
                    className={"btn btn-outline-secondary"}
                    onClick={() => this.setState({ showConfirm: false })}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showSelectLocation}
          contentLabel={"Registration"}
          className={"input-modal"}
        >
          <SignUpCommercial
            email={this.state.email}
            onSubmit={this.handleSignUpCommercial}
            onCloseModal={() => this.setState({ showSelectLocation: false })}
          />
        </Modal>
      </div>
    );
  }
}
